"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveCurrentToColumnAction = void 0;
const logic_types_1 = require("../logic-types");
class MoveCurrentToColumnAction {
    get cardIndex() {
        var _a;
        return (_a = this.card) === null || _a === void 0 ? void 0 : _a.index;
    }
    get cardId() {
        var _a;
        return (_a = this.card) === null || _a === void 0 ? void 0 : _a.cardId;
    }
    constructor(board, columnId) {
        this.board = board;
        this.columnId = columnId;
    }
    validate() {
        const originPile = this.board.getPileByPileId(logic_types_1.PileId.CardStackCurrent);
        return originPile.hasCards;
    }
    execute() {
        const originPile = this.board.getPileByPileId(logic_types_1.PileId.CardStackCurrent);
        if (originPile.cardCount !== 1) {
            throw new Error("Current pile does not contain only 1 card");
        }
        this.card = originPile.lastCard;
        if (this.card === undefined) {
            throw new Error("Invalid card");
        }
        const targetPile = this.board.getPileByPileId(this.columnId);
        originPile.removeCard(this.card);
        targetPile.addCard(this.card);
    }
    resolve() {
        // Nothing to do
    }
    static isAction(action) {
        return action instanceof MoveCurrentToColumnAction;
    }
}
exports.MoveCurrentToColumnAction = MoveCurrentToColumnAction;
